var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34.5 34.5",
    style: {
      enableBackground: "new 0 0 34.5 34.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#707070;}\n\t.st1{fill:#E30000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.2,34.5C7.7,34.5,0,26.8,0,17.2S7.7,0,17.2,0s17.2,7.7,17.2,17.2C34.5,26.8,26.8,34.5,17.2,34.5z M17.2,1 C8.3,1,1,8.3,1,17.2s7.3,16.2,16.2,16.2s16.2-7.3,16.2-16.2C33.5,8.3,26.2,1,17.2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.2,25.4c-0.1,0-0.2,0-0.3-0.1L14.8,24c-5.7-3.7-5.7-6.4-5.7-7.4c0-2.5,1.9-4.5,4.4-4.5 c1.5,0,2.9,0.7,3.7,1.9c1.4-2,4.2-2.6,6.2-1.2c1.2,0.8,1.9,2.2,1.9,3.7c0,1,0,3.7-5.7,7.4l-2.1,1.4C17.5,25.4,17.4,25.4,17.2,25.4 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteFill);
export default __webpack_public_path__ + "static/media/favorite_fill.264669cc0ac6eedafab4fc73ffe7470c.svg";
export { ForwardRef as ReactComponent };